import {ngAsync} from 'shared/utils/ng-@decorators';
import type {ForeignOccurrence, PlainAvailability} from 'typings/portaro.be.types';
import type {AjaxService} from 'core/data-services/ajax.service';

export default class ForeignDocumentDataService {
    public static serviceName = 'foreignDocumentDataService';

    public static readonly FOREIGN_OCCURRENCES_ROUTE = 'foreign-occurrences';
    public static readonly FOREIGN_AVAILABILITY_PATH = 'foreign-availability';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getDocumentOccurrences(recordId: string): Promise<ForeignOccurrence[]> {
        return this.ajaxService
            .createRequest(`${ForeignDocumentDataService.FOREIGN_OCCURRENCES_ROUTE}`)
            .get({record: recordId});
    }

    @ngAsync()
    public async getDocumentAvailability(foreignOccurrenceId: number): Promise<PlainAvailability> {
        return this.ajaxService
            .createRequest(`${ForeignDocumentDataService.FOREIGN_OCCURRENCES_ROUTE}/${foreignOccurrenceId}/${ForeignDocumentDataService.FOREIGN_AVAILABILITY_PATH}`)
            .get();
    }

}